module.exports = __webpack_public_path__ + "img/pv.687bf9ad.png";